module.exports = __webpack_public_path__ + "img/lucas.242022e9.jpg";